import React from 'react'

function PartIcon() {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={50}
        height={50}
        viewBox="0 0 24 24"
        fill='#fff'
    >
        <path d="M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-7 18H4V4h10Zm6 0h-4V4h4Z" />
    </svg>
  )
}

export default PartIcon